import React from 'react';
import { FormComponent, FormComponentProps } from '../index';
import { useTranslation } from 'react-i18next';
import css from './button.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import LoadingSpinner from '../../common/loading-spinner';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

export enum ButtonStyling {
  primary = 'primary',
  secondary = 'secondary',
  cancel = 'cancel',
  action = 'action',
}

export default function Button(
  name: string,
  click?: (event: any) => void,
  label?: string,
  icon?: IconDefinition,
  loadingFragment?: string,
  ignoreValidation?: boolean,
  styling?: ButtonStyling,
  customIcon?: string
): FormComponent {
  const buttonLoadingFragment = loadingFragment;

  return ({ loadingFragment, ...rest }) => (
    <ButtonComponent
      name={name}
      click={click}
      label={label}
      icon={icon}
      styling={styling}
      loadingFragment={loadingFragment}
      ignoreValidation={ignoreValidation}
      buttonLoadingFragment={buttonLoadingFragment}
      customIcon={customIcon}
      {...rest}
    />
  );
}

export function ButtonComponent({
  name,
  label,
  click,
  disabled,
  icon,
  loadingFragment,
  ignoreValidation = false,
  buttonLoadingFragment,
  styling = ButtonStyling.primary,
  customIcon,
}: FormComponentProps & {
  name: string;
  click: (event: any) => void;
  label: string;
  icon?: IconDefinition;
  loadingFragment?: string;
  ignoreValidation?: boolean;
  buttonLoadingFragment?: string;
  styling?: ButtonStyling;
  customIcon?: string;
}) {
  const { t } = useTranslation();
  const buttonLabel = label ? t(label) : t(name);
  const formState = useFormContext()?.formState;
  const isValid = formState?.isValid;
  const { isLoading } = useSelector((state: RootState) => ({
    isLoading: state.global.loadingFragments[loadingFragment],
  }));

  return (
    <button
      name={name}
      type={click ? 'button' : 'submit'}
      disabled={
        disabled || (!ignoreValidation && isValid === false) || !!isLoading
      }
      className={`${css['button']} ${css[styling]}`}
      onClick={click}
    >
      {icon ? <FontAwesomeIcon icon={icon} /> : ''}
      {customIcon && <img src={customIcon} alt="" />}
      {(!click || buttonLoadingFragment) && (
        <LoadingSpinner
          loadingFragment={
            buttonLoadingFragment ? buttonLoadingFragment : loadingFragment
          }
          className={css['spinner']}
        />
      )}
      <span>{buttonLabel}</span>
    </button>
  );
}
